import { render, staticRenderFns } from "./EmbedHeaderTodayButton.vue?vue&type=template&id=32325380&"
import script from "./EmbedHeaderTodayButton.vue?vue&type=script&lang=js&"
export * from "./EmbedHeaderTodayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32325380')) {
      api.createRecord('32325380', component.options)
    } else {
      api.reload('32325380', component.options)
    }
    module.hot.accept("./EmbedHeaderTodayButton.vue?vue&type=template&id=32325380&", function () {
      api.rerender('32325380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/EmbedHeader/EmbedHeaderTodayButton.vue"
export default component.exports